import { render, staticRenderFns } from "./BaseScreen.vue?vue&type=template&id=03183e3d&scoped=true"
import script from "./BaseScreen.vue?vue&type=script&lang=js"
export * from "./BaseScreen.vue?vue&type=script&lang=js"
import style0 from "./BaseScreen.vue?vue&type=style&index=0&id=03183e3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03183e3d",
  null
  
)

export default component.exports